export enum RSVPValue {
  Unset,
  Yes,
  No
}

export namespace RSVPValue {
  export function values() {
    return [
      RSVPValue.Yes,
      RSVPValue.No
    ]
  }

  export function allValues() {
    return [
      RSVPValue.Unset,
      RSVPValue.Yes,
      RSVPValue.No
    ]
  }

  export function displayView(type: RSVPValue): string {
    switch (type) {
      case RSVPValue.Yes:
        return 'Yes'
      case RSVPValue.No:
        return 'No'
      default:
        return '';
    }
  }
}
  